import React from "react";

import "./style.css";

function NeonLoader() {
  return (
    <div className="loader__container">
      <div className="loader__spinner__container">
        <div className="loader"></div>
      </div>
    </div>
  );
}

export default NeonLoader;
